import { Component } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { NgbNavChangeEvent } from "@ng-bootstrap/ng-bootstrap";
import { RouterOutlet } from "@angular/router";
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ConvertDatetimePipe } from "../../app/convert-datetime.pipe";

@Component({
  selector: "app-operational-reports",
  templateUrl: "./operational-reports.component.html",
  styleUrls: ["./operational-reports.component.scss"],
  standalone: true,
  imports: [RouterOutlet,NgbNavModule],
  

})
export class OperationalReportsComponent {
  activeTab: string = "audit"; // Default to 'audit'
  public today: Date;
  constructor(private router: Router,) {
    this.utcTime();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activeTab = event.urlAfterRedirects.split("/").pop();
      }
    });
  }
  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }
  onTabChange(event: NgbNavChangeEvent) {
   
    console.log(event.nextId,'event')
    this.activeTab = event.nextId;
    console.log(this.activeTab);
    this.router.navigate([`operation-reports/${this.activeTab}`]);
  }
}
